import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';

import { ApplicationErrors } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';
import { ImageDataDesign } from 'ib/internetbank-core/ib-models/image-data-design';

import { FieldOptions } from '../../../../../../ui/controls/field.model';
import { TabItem } from '../../../../../../ui/controls/tabs-field/tab-item';
import { CustomFormControl } from '../../../../../../ui/custom-reactive-forms/custom-form-control';
import { ChargeForWidget } from '../charge-item/change-item-entites';


@Component({
	selector: 'app-charge-widget',
	templateUrl: './charge-widget.component.html',
	styleUrls: ['./charge-widget.component.less'],
	standalone: false,
})
export class ChargeWidgetComponent implements OnInit {

	@Input()
	public widgetIcon?: ImageDataDesign;

	@Input()
	public widgetTitle: string | undefined;

	@Input()
	public charges: Array<ChargeForWidget> = [];

	@Input()
	public subscriptionsAbsence: boolean;

	@Output()
	public addSubscriptionClick: EventEmitter<void> = new EventEmitter();

	@Output()
	public tabSubscriptionActivate: EventEmitter<void> = new EventEmitter();

	@Output()
	public tabSearchActivate: EventEmitter<void> = new EventEmitter();

	public searcErrors: ApplicationErrors | null;

	public pending: boolean;

	public tabsControl: CustomFormControl;
	public searchDocNumber: string | undefined;

	private tabs: Array<TabItem<string>> = [
		new TabItem('Подписки', 'tab1'),
		new TabItem('Поиск начислений', 'tab2'),
	];

	constructor() {
		this.tabsControl = new CustomFormControl(
			new FieldOptions({
				'@type': 'tabs-field',
				name: 'receiverAttributeTypesTab',
				css: { classList: ['taby'] },
				value: this.tabs[0].value,
				items: this.tabs,
			}),
		);
	}

	public ngOnInit(): void {
		this.initTabsControl();
	}

	public toSearch(): void {
		this.tabsControl.setValue(this.tabs[1].value);
	}

	public addSubscription(): void {
		this.addSubscriptionClick.emit();
	}

	public startSearch(searchText?: string): void {
		this.pending = true;
		this.charges = [];
		this.searchDocNumber = searchText;
	}

	public stopSearch(): void {
		this.pending = false;
	}

	private initTabsControl(): void {
		this.tabsControl.valueChanges
			.subscribe((tab: string) => {
				this.charges = this.charges || [];
				if (tab === (this.tabsControl.fieldOptions.items && this.tabsControl.fieldOptions.items[0].value)) {
					this.tabSubscriptionActivate.emit();
				}
				if (tab === (this.tabsControl.fieldOptions.items && this.tabsControl.fieldOptions.items[1].value)) {
					this.searcErrors = null;
					this.charges = [];
					this.tabSearchActivate.emit();
				}
			});
	}
}
